import React, { useCallback, useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

import placeholder from '../../assets/img/placeholder.jpg';
import { useStyleString } from '../../hooks';

const useStyles = makeStyles(createStyles({
  root: {
    border: '2px dashed #ccc',
    maxWidth: '100%',
  },
}), { name: 'ImagePreview' });

type Props = {
  src: string;
  styles: string;
  className?: string;
};

const ImagePreview = ({
  src,
  className,
  styles,
}: Props) => {
  const classes = useStyles();
  const [url, setUrl] = useState(placeholder);

  useEffect(() => {
    setUrl(src || placeholder);
  }, [src, setUrl]);

  const errorHandler = useCallback(() => {
    setUrl(placeholder);
  }, [setUrl]);

  const stylesClassname = useStyleString(styles);

  return (
    <img
      src={url}
      alt="Preview"
      className={clsx(className, stylesClassname, classes.root)}
      onError={errorHandler}
    />
  );
};

export default ImagePreview;
